import React, {useCallback, useEffect, useRef, useState} from "react";
import {observer} from "mobx-react";
import {
    IRevolutPaymentMethodViewModel
} from "../../../../services/booking/models/payment/methods/revolut/revolut-payment-method.view-model.interface";
import styled from "styled-components";
import {
    IRevolutPaymentControllerViewModel
} from "../../../../services/booking/models/payment/methods/revolut/revolut-payment-controller.view-model.interface";
import {useServices} from "../../../../hooks/use-services.hook";
import {reaction} from "mobx";

const RevolutButtonBox = styled.div`
  
`

export const RevolutButtonComponent: React.FC<{revolutPaymentMethod: IRevolutPaymentMethodViewModel}> = observer((props) => {
    const services = useServices();
    const booking = services.booking.current;
    const buttonContainerRef = useRef<HTMLDivElement | null>(null);
    const [controller, setController] = useState<IRevolutPaymentControllerViewModel | null>(null);
    const {revolutPaymentMethod} = props;

    const createController = useCallback(async ()=> {
        const paymentController = await revolutPaymentMethod.createPaymentController();
        setController(paymentController);
    }, [revolutPaymentMethod]);

    useEffect(() => {
        const reactionDispose = reaction(() => [services.language.currentLanguage, booking.balanceDue],
            async () => {
                setController(null);
            })

        return () => reactionDispose();
    }, [createController, services.language.currentLanguage, booking.balanceDue]);

    useEffect(() => {
        if(buttonContainerRef.current && !controller) {
            createController();
        }

    }, [createController, controller]);

    useEffect(() => {
        if(controller && buttonContainerRef.current) {
            controller.mount(buttonContainerRef.current);
        }

        return () => {
            if(controller) {
                controller.dispose();
            }
        }

    }, [controller]);

    return (<RevolutButtonBox ref={buttonContainerRef}/>);
})
